import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { TaskTemplate } from '../../../types/TaskTemplate';

export const fetchTaskTemplate = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;
  
  const response = await CustomAxios.get<TaskTemplate>(`task_templates/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetTaskTemplateByIdProps {
  uuid?: string;
}
export function useGetTaskTemplateById({ uuid }: UseGetTaskTemplateByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allTaskTemplates, uuid],
    queryFn: () => fetchTaskTemplate(uuid)
  });

  return query;
}
